import styled from 'styled-components'

export const TaskList = styled.div`
  padding: .2em 0 .2em 0;
  background: ${ ({ theme }) => theme.colorSidebarBg };
`
